module.exports = __webpack_public_path__ + "static/img/son1_active.f98493fb.png";